import { Redirect } from 'expo-router';

// Redirect old /guidelines URL to /terms-of-service
// This prevents 404s from cached Google search results
export default function Guidelines() {
  return <Redirect href="/terms-of-service" />;
}
